import Button from '@repo/button';
import Input from '@repo/input';
import { IoAdd, IoClose } from 'react-icons/io5';
import './CompositionInput.css';

export interface CompositionItem {
    value: string;
    count: number;
}

export interface CompositionInputProps {
    value?: CompositionItem[];
    onChange?: (value: CompositionItem[]) => void;
    error?: string;
    label?: string;
}

const defaultItem: CompositionItem = { value: '', count: 0 };

export default function CompositionInput({
    value = [defaultItem],
    onChange,
    error,
    label = 'Состав',
}: CompositionInputProps) {
    const items = value.length > 0 ? value : [defaultItem];

    const updateItems = (newItems: CompositionItem[]) => {
        onChange?.(newItems);
    };

    const handleValueChange = (index: number, valueStr: string) => {
        const newItems = [...items];
        newItems[index] = { ...newItems[index], value: valueStr };
        updateItems(newItems);
    };

    const handleCountChange = (index: number, countStr: string) => {
        const count = countStr === '' ? 0 : Math.max(0, parseInt(countStr, 10) || 0);
        const newItems = [...items];
        newItems[index] = { ...newItems[index], count };
        updateItems(newItems);
    };

    const handleAdd = () => {
        updateItems([...items, { value: '', count: 0 }]);
    };

    const handleRemove = (index: number) => {
        if (items.length > 1) {
            updateItems(items.filter((_, i) => i !== index));
        }
    };

    return (
        <div className="composition-input">
            <label>{label}</label>
            {items.map((item, index) => (
                <div key={index} className="composition-input-row">
                    <div className="form-group" style={{ flex: 1 }}>
                        <Input
                            placeholder="Название (например: Розы)"
                            value={item.value}
                            onChange={(e) => handleValueChange(index, e.target.value)}
                        />
                    </div>
                    <div className="form-group">
                        <Input
                            type="number"
                            min={0}
                            step={1}
                            placeholder="Кол-во"
                            value={item.count === 0 ? '' : item.count}
                            onChange={(e) => handleCountChange(index, e.target.value)}
                        />
                    </div>
                    {items.length > 1 && (
                        <Button
                            variant="secondary-icon"
                            type="button"
                            onClick={() => handleRemove(index)}
                        >
                            <IoClose />
                        </Button>
                    )}
                    {index === items.length - 1 && (
                        <Button variant="secondary-icon" type="button" onClick={handleAdd}>
                            <IoAdd />
                        </Button>
                    )}
                </div>
            ))}
            {error && <span className="error-message">{error}</span>}
        </div>
    );
}
